import AuthService from '@/services/auth/AuthService';

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    // Resolves with { result: "SUCCEEDED" | "OTP_REQUIRED" | "FAILED", ... }; commits only on SUCCEEDED.
    login({ commit }, user) {
      return AuthService.login(user).then(
        res => {
          if(res.result === "SUCCEEDED"){
            commit('loginSuccess', res.user);
          }
          return res;
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    // Resolves with the full result { result: "SUCCEEDED" | "OTP_REQUIRED" | "FAILED", ... } so the
    // component can branch into the SMS-code step. Only commits the session on SUCCEEDED.
    superAdminLogin({ commit }, user) {
      return AuthService.superAdminlogin(user).then(
          res => {
            if(res.result === "SUCCEEDED"){
              commit('loginSuccess', res.user);
            }
            return res;
          },
          error => {
            commit('loginFailure');
            return Promise.reject(error);
          }
      );
    },
    // Shared SMS-code verification (superadmin + merchant).
    verifyLogin({ commit }, payload) {
      return AuthService.verifyLogin(payload).then(
          res => {
            if(res.result === "SUCCEEDED"){
              commit('loginSuccess', res.user);
            }
            return res;
          },
          error => {
            commit('loginFailure');
            return Promise.reject(error);
          }
      );
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    }
  },
  mutations: {
    loginSuccess(state, user) {
      if(user !== null){
        state.status.loggedIn = true;
        state.user = user;
      } else {
        state.status.loggedIn = false;
        state.user = null;
      }
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    }
  }
};
